import React from 'react';
import { Navigate } from 'react-router-dom';
import { INSTALLER_TYPES } from '../../constants';
import { useAuth } from '../../hooks';

export default function AdminGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuth();
  const isAdmin = user?.installer_role === INSTALLER_TYPES.ADMIN;
  return isAdmin ? (
    <>{children}</>
  ) : (
    <Navigate to="/settings/profile" replace />
  );
}
